import { ISelectorData } from '../../components/application/NewApplication';
import * as Yup from 'yup';
import React from 'react';
import { Shape } from '../yup_types';
import { DATE_FILTER_FORM_FIELDS } from '../order/date-picker-form';
import { TypeAttributes } from 'rsuite/cjs/internals/types';
import { InputType } from '../../components/form/form-input-constants';

export enum PAYMENT_REPORT_FORM_FIELDS {
	REPORT_TYPE = 'reportType',
	MERCHANT = 'merchant',
	DATE_START = 'from',
	DATE_END = 'to',
	TIMEZONE = 'timezone'
}

export enum PAYMENT_REPORT_FORM_FIELDS_NAMES {
	REPORT_TYPE = 'REPORTS.LABEL.REPORT_TYPE',
	MERCHANT = 'REPORTS.LABEL.MERCHANT',
	DATE_START = 'REPORTS.LABEL.DATE_START',
	DATE_END = 'REPORTS.LABEL.DATE_END',
	TIMEZONE = 'REPORTS.LABEL.TIMEZONE',
}

export type PaymentReportFieldsTypes = {
	[PAYMENT_REPORT_FORM_FIELDS.REPORT_TYPE]: string;
	[PAYMENT_REPORT_FORM_FIELDS.MERCHANT]: string;
	[PAYMENT_REPORT_FORM_FIELDS.DATE_END]: string;
	[PAYMENT_REPORT_FORM_FIELDS.DATE_START]: string;
	[PAYMENT_REPORT_FORM_FIELDS.TIMEZONE]: string;
};
export type PaymentReportFieldsReturnTypes = {
	reportId: string,
	mid: string,
	from: string | Date | null,
	to: string | Date | null,
	timezone: string | null,
};

// @ts-ignore
export const getPaymentReportDetailsSchema = (t): Yup.SchemaOf<PaymentReportFieldsTypes> => Yup.object<Shape<PaymentReportFieldsTypes>>().shape({
	[PAYMENT_REPORT_FORM_FIELDS.REPORT_TYPE]: Yup.string()
		.typeError(t('REPORTS.VALIDATION.REPORT_TYPE'))
		.required(t('REPORTS.VALIDATION.REPORT_TYPE')),
	[PAYMENT_REPORT_FORM_FIELDS.DATE_START]: Yup.string()
		.typeError(t('REPORTS.VALIDATION.DATE_START'))
		.required(t('REPORTS.VALIDATION.DATE_START')),
	[PAYMENT_REPORT_FORM_FIELDS.DATE_END]: Yup.string()
		.typeError(t('REPORTS.VALIDATION.DATE_END'))
		.required(t('REPORTS.VALIDATION.DATE_END')),
	[PAYMENT_REPORT_FORM_FIELDS.TIMEZONE]: Yup.string()
		.typeError(t('REPORTS.VALIDATION.TIMEZONE'))
		.required(t('REPORTS.VALIDATION.TIMEZONE')),
});

export const initialPaymentReportValues: PaymentReportFieldsTypes = {
	[PAYMENT_REPORT_FORM_FIELDS.REPORT_TYPE]: '',
	[PAYMENT_REPORT_FORM_FIELDS.MERCHANT]: '',
	[PAYMENT_REPORT_FORM_FIELDS.DATE_START]: null,
	[PAYMENT_REPORT_FORM_FIELDS.DATE_END]: null,
	[PAYMENT_REPORT_FORM_FIELDS.TIMEZONE]: '',

};

export const getFormattedPaymentReportFormFields = (formikValues): PaymentReportFieldsReturnTypes => ({
	reportId: formikValues?.[PAYMENT_REPORT_FORM_FIELDS.REPORT_TYPE],
	mid: formikValues?.[PAYMENT_REPORT_FORM_FIELDS.MERCHANT] ? formikValues?.[PAYMENT_REPORT_FORM_FIELDS.MERCHANT] : '',
	from: formikValues?.[PAYMENT_REPORT_FORM_FIELDS.DATE_START],
	to: formikValues?.[PAYMENT_REPORT_FORM_FIELDS.DATE_END],
	timezone: formikValues?.[PAYMENT_REPORT_FORM_FIELDS.TIMEZONE]
});

export interface IPaymentReportFields {
	key: string;
	fieldName: PAYMENT_REPORT_FORM_FIELDS | DATE_FILTER_FORM_FIELDS;
	placeholder?: string;
	label: string;
	inputType: InputType.Select | InputType.Date;
	additionalClasses?: string;
	data?: ISelectorData[];
	placement?: TypeAttributes.Placement;
	required?: boolean;
	renderMenu?: (menu: React.ReactElement) => React.ReactElement;
	searchBy?: (keyword: string) => boolean;
	isTimePicker?: boolean;
	searchable?: boolean;
}
